import React from 'react';

export const ResendEmailIcon = (props) => {
  const { className = '', style = {}, onClick } = props;
  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6703 19.4773H18.6923L18.6746 19.4595C18.6731 19.4654 18.6717 19.4713 18.6703 19.4773Z"
        fill="#113E57"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.19409 19.4773H18.6703C18.54 20.0216 18.4706 20.5831 18.4706 21.1446H4.80387C3.61546 21.1446 2.6665 20.1779 2.6665 19.0072V7.94791C2.6665 6.7595 3.61546 5.81055 4.80387 5.81055H22.701C23.8894 5.81055 24.8383 6.77724 24.8383 7.94791V15.2025C24.6432 15.1848 24.4392 15.1759 24.2352 15.1759C23.8539 15.1759 23.4903 15.2203 23.1444 15.2735V8.64854L18.2666 13.5529L21.0514 16.0628C20.5636 16.3732 20.1468 16.7634 19.8009 17.198L17.0693 14.7414L15.6769 16.1515C14.5683 17.2512 12.9188 17.2512 11.819 16.1515L10.4355 14.7591L5.19409 19.4773ZM14.5063 14.9631L21.9294 7.50447H5.58432L13.0074 14.9631C13.4509 15.3976 14.0628 15.3976 14.5063 14.9631ZM4.36043 8.65741V17.9784L9.2471 13.5707L4.36043 8.65741Z"
        fill="#113E57"
      />
      <path
        d="M21.779 17.7379C24.147 15.9553 27.6235 16.7446 28.9272 19.6092V19.6181H28.9361C29.6545 21.2056 29.3795 23.1389 28.2621 24.4693C26.2311 26.8904 22.6482 26.6776 20.8655 24.3274C20.3068 23.5824 20.0053 22.7221 19.9343 21.8441C19.9255 21.5958 20.1206 21.4095 20.36 21.4184H21.8854C22.0983 21.4184 22.2491 21.5958 22.2845 21.8086C22.3378 22.19 22.4885 22.5713 22.7368 22.9084C23.5173 23.9371 24.9984 24.15 26.0271 23.3695C27.0737 22.5891 27.2688 21.108 26.4883 20.0792C25.7079 19.0327 24.2268 18.8376 23.198 19.6181L23.9075 20.5581L20.4753 20.5227C20.2625 20.5227 20.1117 20.3187 20.1649 20.1058L21.0695 16.7978L21.779 17.7379Z"
        fill="#113E57"
      />
    </svg>
  );
};
